exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert_1[data-v-14149812]{z-index:200}.card[data-v-14149812]{width:20rem;margin-top:2%;position:relative}.container[data-v-14149812]{margin-top:5%;background-size:cover;background-position:50%;background-repeat:repeat-y}.items h4[data-v-14149812]{font-size:24px;font-weight:700;text-align:center;text-transform:capitalize;margin-bottom:0;margin-top:5px}.items img[data-v-14149812]{opacity:.85;width:18rem}.items img[data-v-14149812]:hover{opacity:1}a[data-v-14149812]:hover{color:#07aa59}.AddToBag[data-v-14149812]{text-align:center;padding:5px}.AddToBag a[data-v-14149812]{color:#000}button[data-v-14149812]:focus{outline:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-14149812","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Items.vue
// module id = 623
// module chunks = 0